import React from "react";
import { Link } from "react-router-dom";


const HelpList = ({ title, items }) => {
  return (
    <>
      <h3 className="text-[#666] font-semibold text-[24px] md:text-[28px] mt-12 md:mt-22 mb-4">
        {title}
      </h3>
      <div className="max-w-full md:max-w-[980px] mb-5">
        {items.map((item, index) => (
          <div
            key={index}
            className="flex items-start gap-4 mb-5 last:mb-0"
          >
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#FFF3DC] border border-[#E59B2D] flex items-center justify-center mt-[2px]">
              <span className="text-[13px] font-semibold text-[#C47B10]">
                {index + 1}
              </span>
            </div>
            <div className="flex flex-col">
              <p className="text-[13px] font-semibold text-[#C47B10] mb-[2px]">
                {item.heading}
              </p>
              <p className="text-[14px] md:text-[16px] text-[#4E4E4E] leading-relaxed">
                {item.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-8">
        <Link
          to="/contactus"
          className="ml-11 bg-[#ff9219] text-white mt-[8px] py-[10px] px-[50px] rounded-[4px] font-medium hover:bg-slate-400 transition-all duration-300 ease-in-out"
        >
          Book Now
        </Link>
      </div>
    </>
  );
};

export default HelpList;